var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-style-ltr-vubbuv",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    "data-testid": "ArrowDropUpIcon",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 14 5-5 5 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowSummary);
export default __webpack_public_path__ + "static/media/icon-arrow-summary.c989d5e743de7a7cfedb567602474e2f.svg";
export { ForwardRef as ReactComponent };